const OECDDonors = [
  "AUS",
  "AUT",
  "BEL",
  "CAN",
  "CZE",
  "DNK",
  "FIN",
  "FRA",
  "DEU",
  "GRC",
  "HUN",
  "ISL",
  "IRL",
  "ITA",
  "JPN",
  "LUX",
  "NLD",
  "NZL",
  "NOR",
  "POL",
  "PRT",
  "KOR",
  "SVK",
  "SVN",
  "ESP",
  "SWE",
  "CHE",
  "GBR",
  "USA"
];

const OECDRecipients = [
  'AFG',
  'ALB',
  'DZA',
  'AGO',
  'ATG',
  'ARG',
  'ARM',
  'AZE',
  'BGD',
  'BLR',
  'BLZ',
  'BEN',
  'BTN',
  'BOL',
  'BIH',
  'BWA',
  'BRA',
  'BFA',
  'BDI',
  'CPV',
  'KHM',
  'CMR',
  'CAF',
  'TCD',
  'CHL',
  'CHN',
  'COL',
  'COM',
  'COG',
  'CRI',
  'CUB',
  'CIV',
  'PRK',
  'COD',
  'DJI',
  'DMA',
  'DOM',
  'ECU',
  'EGY',
  'SLV',
  'GNQ',
  'ERI',
  'ETH',
  'FJI',
  'GAB',
  'GMB',
  'GEO',
  'GHA',
  'GRD',
  'GTM',
  'GIN',
  'GNB',
  'GUY',
  'HTI',
  'HND',
  'IND',
  'IDN',
  'IRN',
  'IRQ',
  'JAM',
  'JOR',
  'KAZ',
  'KEN',
  'KIR',
  'KGZ',
  'LAO',
  'LBN',
  'LSO',
  'LBR',
  'LBY',
  'MDG',
  'MWI',
  'MYS',
  'MDV',
  'MLI',
  'MHL',
  'MRT',
  'MUS',
  'MEX',
  'FSM',
  'MNG',
  'MNE',
  'MAR',
  'MOZ',
  'MMR',
  'NAM',
  'NRU',
  'NPL',
  'NIC',
  'NER',
  'NGA',
  'PAK',
  'PLW',
  'PAN',
  'PNG',
  'PRY',
  'PER',
  'PHL',
  'MDA',
  'RWA',
  'LCA',
  'VCT',
  'WSM',
  'STP',
  'SEN',
  'SRB',
  'SYC',
  'SLE',
  'SLB',
  'SOM',
  'ZAF',
  'SSD',
  'LKA',
  'SDN',
  'SUR',
  'SWZ',
  'SYR',
  'TJK',
  'THA',
  'MKD',
  'TLS',
  'TGO',
  'TON',
  'TUN',
  'TUR',
  'TKM',
  'TUV',
  'UGA',
  'UKR',
  'TZA',
  'URY',
  'UZB',
  'VUT',
  'VEN',
  'VNM',
  'YEM',
  'ZMB',
  'ZWE'
];

export {
  OECDDonors,
  OECDRecipients
};



// WEBPACK FOOTER //
// ./src/helpers/oecdCountries.js